import type { ComponentProps } from 'react';

import { cn } from '../lib/cn.ts';

/** Скелетон вместо спиннера: сохраняет раскладку, пока данные грузятся. */
export function Skeleton({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      aria-hidden="true"
      className={cn('animate-skeleton rounded-sm bg-surface-2', className)}
      {...props}
    />
  );
}

/**
 * Скелетон строк. С `table` — строки той же высоты, что у `DataTable` (отступы, граница, строка текста):
 * когда придут данные, таблица не дёрнется на разницу высот.
 */
export function SkeletonRows({
  rows = 5,
  columns = 4,
  table = false,
}: {
  rows?: number;
  columns?: number;
  table?: boolean;
}) {
  return (
    <div className="flex flex-col" aria-busy="true">
      {Array.from({ length: rows }, (_, r) => (
        <div
          key={r}
          className={cn(
            'flex gap-4 border-t border-border-soft px-3',
            table ? 'min-h-[calc(2.3rem+1px)] items-center py-2' : 'py-2.5 first:border-t-0',
          )}
        >
          {Array.from({ length: columns }, (__, c) => (
            <Skeleton key={c} className={cn('h-3.5', c === 0 ? 'w-2/5' : 'w-1/6')} />
          ))}
        </div>
      ))}
    </div>
  );
}
